import { Factions } from "../../../enums/factions.enum";
import { Races } from "../../../enums/races.enum";

export const races: { race: Races; faction: Factions }[] = [
  {
    race: Races.HUMAN,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.DWARF,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.GNOME,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.NIGHTELF,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.DRAENEI,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.WORGEN,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.MURGOLOC,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.PANDAREN_ALLIANCE,
    faction: Factions.ALLIANCE,
  },
  {
    race: Races.ORC,
    faction: Factions.HORDE,
  },
  {
    race: Races.UNDEAD,
    faction: Factions.HORDE,
  },
  {
    race: Races.TAUREN,
    faction: Factions.HORDE,
  },
  {
    race: Races.TROLL,
    faction: Factions.HORDE,
  },
  {
    race: Races.BLOODELF,
    faction: Factions.HORDE,
  },
  {
    race: Races.GOBLIN,
    faction: Factions.HORDE,
  },
  {
    race: Races.OGRE,
    faction: Factions.HORDE,
  },
  {
    race: Races.PANDAREN_HORDE,
    faction: Factions.HORDE,
  },
];
